import { createSelector } from 'reselect';
import { initialSettingsState } from '.';
// Leaving createSelector commented out because it's not used at the moment
// Use createSelector when you want to do some computational selection and uncomment the below
// import { createSelector } from 'reselect';

const DEFAULT_RISK_FORECAST_VESSEL_LENGTH = 4.5;

// Non-computational

// NOTE: measurementSystem should always be set, as it pulls data from the window DECKEE_CONFIG,
// but just incase defaulting to metric
export const selectMeasurementSystemConfig = (state) =>
  state.appControls?.memberSettings?.unitsConfig?.measurementSystem || 'metric';

export const selectTripsConfig = (state) =>
  state.appControls.memberSettings.tripsConfig;
export const selectWeatherConfig = (state) =>
  state.appControls.memberSettings.weatherConfig;

export const getPrepareLocation = (state) =>
  state.appControls.memberSettings.waterBodyDefinitionConfig;

export const getNotificationLastSeenDate = (state) =>
  state.appControls.memberSettings.notificationConfig?.lastSeenDate || '';

export const getPaywallLastSeenDate = (state) =>
  state.appControls.memberSettings.paywallConfig?.lastSeenDate || '';

export const selectWeatherLayoutConfig = createSelector(
  (state) => state.appControls.memberSettings.weatherLayoutConfig,
  (weatherLayoutConfig) => {
    const RISK_FORECAST_KEY = 'riskForecast';
    const config = [...weatherLayoutConfig];

    // Inject the risk forecast config if it's not already there - this is so existing member settings do not hide the new graph from
    // showing. Ideally, we would merge the two configs, but this is a quick fix for now.
    const riskForecastConfig = config.find((i) => i.id === RISK_FORECAST_KEY);
    const initialRiskForecastConfig =
      initialSettingsState.memberSettings.weatherLayoutConfig.find(
        (i) => i.id === RISK_FORECAST_KEY,
      );
    if (initialRiskForecastConfig && !riskForecastConfig) {
      config.push(initialRiskForecastConfig);
    }

    return config;
  },
);
export const selectRiskForecastVesselLength = (state) =>
  state.appControls.memberSettings?.riskForecastConfig?.vesselLength ||
  DEFAULT_RISK_FORECAST_VESSEL_LENGTH;
export const selectLocationConfig = (state) => ({
  ...initialSettingsState.memberSettings.locationConfig,
  ...state.appControls.memberSettings.locationConfig,
});
export const selectMapHolderOffset = (state) =>
  state.appControls.mapHolderOffset;
export const selectAppViewportSize = (state) =>
  state.appControls.appViewportSize;
export const selectShowingSearchBar = (state) =>
  state.appControls.showingSearchBar;
export const selectShowingFollowButton = (state) =>
  state.appControls.showingFollowButton;
export const selectShowingMenuBar = (state) => state.appControls.showingMenuBar;
export const selectCurrentMapCenter = (state) =>
  state.appControls.currentMapParams.viewPortDetails.center;
export const selectDropPinLocation = (state) =>
  state.appControls.dropPinLocation;
export const selectShowingSlideUpMenu = (state) =>
  state.appControls.showingSlideUpMenu;

export const selectShowingBottomControlPane = (state) =>
  state.appControls.showingBottomControlPane;
export const selectShowingSearchButton = (state) =>
  state.appControls.showingSearchButton;
export const selectShowingSignalButton = (state) =>
  state.appControls.showingSignalButton;
export const selectShowingFriendsButton = (state) =>
  state.appControls.showingFriendsButton;

// Computational

// This is done like this because of how nested the member settings are. Every time we fetch and update member settings, it's creating a new object.
// While this is normally fine, it was causing our GraphSliderContainer to completely re-render the graphs, which was causing the selected time
// to be changed back to the default.
export const selectUnitsConfig = createSelector(
  (state) => state.appControls.memberSettings.unitsConfig.speed,
  (state) => state.appControls.memberSettings.unitsConfig.distance,
  (state) => state.appControls.memberSettings.unitsConfig.windSpeed,
  (state) => state.appControls.memberSettings.unitsConfig.coordinate,
  (state) => state.appControls.memberSettings.unitsConfig.tideHeight,
  (state) => state.appControls.memberSettings.unitsConfig.swellHeight,
  (state) => state.appControls.memberSettings.unitsConfig.temperature,
  (state) => state.appControls.memberSettings.unitsConfig.measurementSystem,

  (
    speed,
    distance,
    windSpeed,
    coordinate,
    tideHeight,
    swellHeight,
    temperature,
    measurementSystem,
  ) => ({
    speed,
    distance,
    windSpeed,
    coordinate,
    tideHeight,
    swellHeight,
    temperature,
    measurementSystem,
  }),
);
